import React from 'react';
import styles from './ShopNext.module.scss';
import { Link } from '@srcDS/components/atoms/link/Link';
import { Reference } from '@apgnext/frontend//types/reference';

interface ShopNextConfiguration {
  shopNextCategory: Reference;
  shopNextCategoryName: string;
  shopNextPrefixText?: string;
}

interface ShopNextData {
  category: Reference;
  categoryName: string;
  prefixText?: string;
}

interface ShopNextProps {
  data: ShopNextData | null;
}

export const getShopNextData = (configuration: ShopNextConfiguration | null): ShopNextData | null => {
  if (!configuration || !configuration.shopNextCategory) {
    return null;
  }
  return {
    category: configuration.shopNextCategory,
    categoryName: configuration.shopNextCategoryName || '',
    prefixText: configuration.shopNextPrefixText,
  };
};

const ShopNext: React.FC<ShopNextProps> = ({ data }) => {
  if (!data) return null;

  const { prefixText, category, categoryName } = data;

  return (
    <div className={styles.root}>
      <div className={styles.rootInner}>
        {prefixText && <span>{prefixText}</span>}
        {category && categoryName && (
          <Link link={{ reference: category }} ariaLabel={categoryName}>
            {categoryName}
          </Link>
        )}
      </div>
    </div>
  );
};

export default ShopNext;
